import TranslatedText from '@sms/plasma-ui/lib/components/TranslatedText/TranslatedText';
import React, { FC } from 'react';

import { IProps } from '../index';

export const DistributionRow: FC<IProps> = ({ statistics }) => {
  return (
    <>
      {statistics && 'segregationsDistribution' in statistics && (
        <li className="seg__statistics__item">
          <p>
            <TranslatedText textKey="side-menu.distribution" />:
          </p>
          <p>{statistics.segregationsDistribution ?? '-'}</p>
        </li>
      )}
    </>
  );
};

